var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullMatchIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1v14h16V1H0zm15 13H1V2h14v12zM14 3H2v10h12V3zM7 8H6v1H5v1H4V9h1V8h1V7H5V6H4V5h1v1h1v1h1v1zm4 2H8V9h3v1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullMatchIcon);
export default __webpack_public_path__ + "static/media/full-match-icon.5ef474bb98c9ce0ff2d29ed9fb9ebc02.svg";
export { ForwardRef as ReactComponent };